<template>
  <div>
    <fee-types-form
      :is-active.sync="isEditing"
      method="put"
      :feeType="editingFeeType"
      @changed="feeTypeUpdated"
    />
    <fee-types-form :is-active.sync="isAdding" @changed="feeTypeAdded" />
    <data-table
      title="Transaction Fee Types"
      ref="table"
      :url="url"
      :headers="headers"
      :archive="false"
      item-key="id"
      searchable
    >
      <v-btn slot="action.icons" color="primary" @click="isAdding = true">
        Add New FeeType
        <v-icon class="ml-2" color="light-blue lighten-4"> mdi-account-money</v-icon>
      </v-btn>

      <template slot="item.actions" slot-scope="{ item }">
        <v-btn small icon @click="updateFeeType(item)">
          <v-icon>mdi-pencil-outline</v-icon>
        </v-btn>
      </template>
    </data-table>
  </div>
</template>
<script>
import FeeTypesForm from "./form";

export default {
  components: {
    FeeTypesForm,
  },
  data() {
    return {
      isAdding: false,
      isEditing: false,
      feeType: {},
      editingFeeType: null,
      url: "/api/v1/transactions/feeTypes",
      headers: {
        id: "ID",
        name: "Name",
        actions: "Actions",
      },
    };
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
  },
  methods: {
    feeTypeAdded({ message }) {
      this.isAdding = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    feeTypeUpdated({ message }) {
      this.editingFeeType = null;
      this.isUpdating = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    updateFeeType(feeType) {
      this.editingFeeType = Object.assign({}, feeType);
      this.isEditing = true;
    },
  },
};
</script>
